import * as qs from "query-string-for-all";
import * as React from "react";
import axios from "axios";
import Loading from "src/components/general/Loading";
import RiskCard from "./RiskCard";
import { baseUrl } from "src/constants/ApiSettings";
import { ICouncil } from "src/interfaces";

interface ITrace {
  surplus: number;
  liability: number;
  asset: number;
  risk: "Lower" | "Moderate" | "Higher";
}

interface IProps {
  council: ICouncil;
  ordinal: number;
  year: string;
}

interface IState {
  data: null | ITrace;
}

export default class CouncilRiskCard extends React.PureComponent<
  IProps,
  IState
> {
  public state: IState = { data: null };

  public componentDidMount() {
    this.generateData(this.props.council, this.props.year);
  }
  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateData(newProps.council, newProps.year);
    }
  }

  public generateData = (council: ICouncil, year: string) => {
    axios
      .all([
        axios.get(
          `${baseUrl}/assetSustainabilityRatio?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/netFinancialLiabilitiesRatio?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/operatingSurplusRatio?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/qaoRelativeRiskAssessmentLevel?${qs.stringify({
            council: council.id,
            year
          })}`
        )
      ])
      .then(
        axios.spread((resAsset, resLiability, resSurplus, resRisk) => {
          const asset = Math.round(resAsset.data[0].value * 100) / 100;
          const liability = Math.round(resLiability.data[0].value * 100) / 100;
          const surplus = Math.round(resSurplus.data[0].value * 100) / 100;
          const risk = resRisk.data[0].value;

          const data: ITrace = {
            asset,
            liability,
            surplus,
            risk
          };

          this.setState({ data });
        })
      )
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  };

  public render() {
    const data = this.state.data;

    if (!data) {
      return (
        <Loading />
      );
    }
    return (
      <RiskCard 
        council={ this.props.council }
        ordinal={ this.props.ordinal }
        risk={ data.risk }
        operatingSurplusRatio={ data.surplus }
        financialLiabilites={ data.liability }
        assetSustainability={ data.asset }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilSustainability/CouncilRiskCard.tsx